import { render, staticRenderFns } from "./ProductRail.vue?vue&type=template&id=43e2b54f&scoped=true"
import script from "./ProductRail.vue?vue&type=script&lang=js"
export * from "./ProductRail.vue?vue&type=script&lang=js"
import style0 from "./ProductRail.vue?vue&type=style&index=0&id=43e2b54f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e2b54f",
  null
  
)

export default component.exports